// MultilevelLinkWithLocation.js
import React from "react";
import { useLocation } from "react-router-dom";
import { MultilevelLink } from "./multiLevelNav";

export function MultilevelLinkWithLocation(props) {
  const location = useLocation();
  return <MultilevelLink {...props} location={location} />;
}
